/* Open header mega-menus on hover (desktop pointers only).

   Dawn's menus are <details> disclosures that open on click. This layers hover on top:
   mouseenter opens, mouseleave closes after a short grace period so the cursor can travel
   from the trigger into the panel without it snapping shut. Click behaviour is untouched,
   so touch devices and keyboard users keep the native toggle.
*/
(function () {
  if (!window.matchMedia('(pointer: fine)').matches) return;

  var CLOSE_DELAY = 150;

  document.querySelectorAll('header-menu > details, .header__inline-menu details').forEach(function (details) {
    var host = details.closest('header-menu') || details;
    var timer = null;

    host.addEventListener('mouseenter', function () {
      if (timer) { clearTimeout(timer); timer = null; }
      if (!details.open) {
        details.open = true;
        var summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    });

    host.addEventListener('mouseleave', function () {
      timer = setTimeout(function () {
        if (details.open) {
          details.open = false;
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }
      }, CLOSE_DELAY);
    });

    /* With hover handling the dropdown, a mouse click on the department name
       navigates to its collection page instead of toggling the panel.
       Keyboard activation (e.detail === 0) keeps the native toggle for
       accessibility, and items with no destination keep toggling too. */
    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (e) {
        var url = summary.getAttribute('data-d2f-url');
        if (url && e.detail > 0) {
          e.preventDefault();
          window.location.href = url;
        }
      });
    }
  });
})();
